import { Dispatch, SetStateAction, createContext } from 'react'

import { AlertType, AlertTypeKeyString } from 'AlertsOfVulnerability/types'

type AlertsTypesForFilterManagerContextType = {
  alertsTypes: AlertType[]
  loadingAlertsTypes: boolean
  selectAlertType: AlertTypeKeyString
  setSelectAlertType: Dispatch<SetStateAction<AlertTypeKeyString>>
}

const defaultValue = {
  alertsTypes: [],
  loadingAlertsTypes: false,
  selectAlertType: {},
  setSelectAlertType: () => {},
}

const AlertsTypesForFilterManagerContext = createContext<AlertsTypesForFilterManagerContextType>(defaultValue)

export default AlertsTypesForFilterManagerContext
